import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect
} from 'react';
import styled from 'styled-components';
import starsPicture from '../../assets/images/star.png';
import { TimelineMax } from 'gsap';
import CrossIcon from '../../assets/images/cross_icon.png';
// import { TimelineMax } from "gsap";
import wrpLogo from '../../assets/images/wrplogo2d.png';

const NavigationWrapper = styled.div`
  height: 100%;
  width: 100vw;
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  opacity: 1;
  background: linear-gradient(to right, #1c0a1c 50%, #fff 50%);
  overflow-x: hidden;
  transition: 0.5s;
  &.hideNavigation {
    opacity: 0;
    visibility: hidden;
  }

  @media (max-width: 767px) {
    background: #fff;
  }
`;

const NavIcon = styled.img`
  position: absolute;
  cursor: pointer;
  top: 19px;
  right: 15px;
  width: 24px;
  height: 24px;
`;

const CompanyTitle = styled.div`
  font-size: 72px;
  font-weight: 900;
  line-height: 98px;
  margin-bottom: 0.5rem;
  /* margin-left: 15%;
  margin-top: 40%; */
  font-family: AvenirBold;
  color: white;
  @media (max-width: 991px) {
    font-size: 42px;
  }
`;
const MenuItemWrapper = styled.div`
  // margin: 0px 20%;
  margin-left: 20%;
  /* margin-top: 30%; */
  // width: 100px;

  &.clickAnimation {
    opacity: 0;
  }
`;
const MenuItemStyle = styled.div`
  font-size: 32px;
  font-family: AvenirBold;
  letter-spacing: 0.24px;
  padding: 7px 0;
  position: relative;
  a {
    font-size: 28px !important;
  }
`;
const MenuItemText = styled.div`
  z-index: 1;
`;
const MenuItemBorder = styled.div`
  width: 120px;
  height: 20px;
  background: #febb39;
  position: absolute;
  bottom: 10px;
  left: -12px;
`;
const CompanyAddress = styled.div`
  font-size: 16px;
  color: #a7a0a7;
  padding-top: 30px;
  // margin: 0 auto;
  margin-left: 20%;
  width: 70%;
`;
const CompanyContact = styled.div`
  font-size: 16px;
  color: #a7a0a7;
  margin-left: 20%;
  width: 70%;
  padding-top: 10px;
`;
const LeftSection = styled.div`
  /* background-color: #1c0a1c; */
`;
const RightSection = styled.div`
  /* background-color: #ffffff; */
  position: relative;
`;
const StyledImage = styled.img`
  width: 250px;
  position: absolute;
  bottom: 12%;
`;
const CloseButton = styled.div`
  position: absolute;
  top: 20px;
  right: 17px;
  cursor: pointer;
`;

const ExternalLinkDiv = styled.div`
  a {
    color: inherit !important;
  }
  a:hover {
    text-decoration: none;
  }
`;

const SpacerDiv = styled.div`
  height: 90px;

  @media (max-width: 566px) {
    height: 50px;
  }
`;

const SmallSpacerDiv = styled.div`
  height: 50px;

  @media (max-width: 566px) {
    height: 30px;
  }
`;

const menuItems = ['About', 'Services', 'Work', 'Careers', 'Contact'];

const Navigation = forwardRef((props, ref) => {
  const [hideNavigation, sethideNavigation] = useState(true);
  useImperativeHandle(ref, () => ({
    toggleNavigation() {
      document.body.style.overflow = !hideNavigation ? 'scroll' : 'hidden';
      sethideNavigation(!hideNavigation);
    }
  }));
  var showOrHideNavigation = hideNavigation ? 'hideNavigation' : '';
  const showNav = () => {
    var navigationTimeline = new TimelineMax();
    navigationTimeline.to(
      '.navWrapper',
      1,
      // { x: 100, y: 100 }
      { x: 0, y: 0, opacity: 1 }
    );
  };

  return (
    <NavigationWrapper className={'navWrapper ' + showOrHideNavigation}>
      <div className='container h-100'>
        <div className='row h-100'>
          <LeftSection className='col col-6 d-none d-md-block'>
            <SpacerDiv />
            <SpacerDiv />
            <CompanyTitle>
              <img src={wrpLogo} style={{ width: '100%', height: 'auto' }} />
            </CompanyTitle>
            <StyledImage src={starsPicture} />
          </LeftSection>
          <RightSection className='col-12 col-md-6'>
            <SpacerDiv />
            <SpacerDiv />
            <SmallSpacerDiv />
            <MenuItemWrapper>
              {menuItems.map((menuItem, index) => {
                return (
                  <MenuItemStyle className='row' key={index}>
                    <MenuItemText>
                      {menuItem !== 'Careers' && (
                        <Link
                          to={'/' + menuItem.toLowerCase()}
                          style={{
                            color: 'inherit',
                            textDecoration: `none`
                          }}
                          onClick={() => {
                            document.body.style.overflow = !hideNavigation
                              ? 'scroll'
                              : 'hidden';
                            sethideNavigation(!hideNavigation);
                          }}>
                          {menuItem}
                        </Link>
                      )}
                      {menuItem === 'Careers' && (
                        <ExternalLinkDiv>
                          <a
                            target='blank'
                            href='https://sites.google.com/a/werplay.com/careers/'
                            onClick={() => sethideNavigation(!hideNavigation)}>
                            Careers
                          </a>
                        </ExternalLinkDiv>
                      )}
                    </MenuItemText>
                    {props.location.match('/' + menuItem.toLowerCase()) && (
                      <MenuItemBorder />
                    )}
                  </MenuItemStyle>
                );
              })}
            </MenuItemWrapper>
            <CompanyAddress>
              Plot# 395/396 Service Rd N, I-9/3,
              <br /> Islamabad, Pakistan.
            </CompanyAddress>
            <CompanyContact>(051) 4859017</CompanyContact>
            <CompanyContact>connect@werplay.com</CompanyContact>
            <NavIcon
              src={CrossIcon}
              onClick={() => {
                document.body.style.overflow = !hideNavigation
                  ? 'scroll'
                  : 'hidden';
                sethideNavigation(!hideNavigation);
              }}
            />
          </RightSection>
        </div>
      </div>
    </NavigationWrapper>
  );
});

Navigation.propTypes = {
  location: PropTypes.string
};

Navigation.defaultProps = {
  location: '/'
};

export { Navigation };
